// extracted by mini-css-extract-plugin
export var root = "_zq-0";
export var scroll = "_zq-1";
export var thumb = "_zq-3";
export var track = "_zq-2";